import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { ProductDataSheetsDownloadsListFragmentFragmentDoc } from '@packages/gql/generated/shopping/ProductDataSheetsDownloadsListFragmentFragmentDoc';
import type { HTMLAttributes } from 'react';
import { DownloadItem } from '../DownloadItem/DownloadItem';

/* GraphQL */ `
  fragment ProductDataSheetsDownloadsListFragment on Product {
    downloads {
      type
      ...DownloadItemFragment
    }
  }
`;

export type ProductDataSheetsDownloadsListProps = HTMLAttributes<HTMLDivElement> & {
  data: FragmentType<typeof ProductDataSheetsDownloadsListFragmentFragmentDoc>;
};

export const ProductDataSheetsDownloadsList = ({
  data,
  className,
  ...props
}: ProductDataSheetsDownloadsListProps) => {
  const { downloads } = getFragmentData(ProductDataSheetsDownloadsListFragmentFragmentDoc, data);

  // Frontend logic - this should be removed once the gql backend supports query batching. -> https://empiriecom.atlassian.net/browse/INFORM-2588
  const productDataSheetsDownloads = downloads.filter(
    (download) => download.type === 'PRODUCT_DATASHEET',
  );

  if (productDataSheetsDownloads.length === 0) {
    return null;
  }

  return (
    <div className={`flex flex-col items-center gap-1.5 ${className || ''}`} {...props}>
      {productDataSheetsDownloads.map((download, idx) => (
        <DownloadItem
          renderIcon={false}
          data={download}
          // index should only be shown, if there is more then one download
          idx={productDataSheetsDownloads.length > 1 ? idx + 1 : undefined}
          // eslint-disable-next-line react/no-array-index-key
          key={idx}
        />
      ))}
    </div>
  );
};
